import { RouteConfig } from 'vue-router'
import MainView from '../views/MainView.vue'
import AlarmView from '../views/AlarmView.vue'
import OrgmapView from '../views/OrgmapView.vue'
import SearchView from '../views/SearchView.vue'
import ScheduleSearchView from '../views/ScheduleSearchView.vue'
const Home = () => import(/* webpackChunkName: "home" */ '@home/Index.vue')
const HomeMaster = () => import(/* webpackChunkName: "home" */ '@home/views/Master.vue')

const routes: RouteConfig[] = [
  {
    path: '/home',
    component: Home,
    children: [
      {
        path: '',
        component: HomeMaster,
        children: [
          {
            path: 'main',
            name: 'home-main',
            component: MainView,
          },
          {
            path: 'alarm',
            name: 'home-alarm',
            component: AlarmView,
          },
          {
            path: 'orgmap',
            name: 'home-orgmap',
            component: OrgmapView,
          },
          {
            path: 'search',
            name: 'home-search',
            component: SearchView,
          },
          {
            path: 'scheduleSearch',
            name: 'home-scheduleSearch',
            component: ScheduleSearchView,
          },
        ],
      },
    ],
  },
]
export default routes
